class WishlistDialog extends HTMLElement {
  constructor () {
    super()

    this.selectedWishlist = false
    this.selectedProduct = false

    this.modalDialog = this.querySelector('.wishlist-dialog')
    this.wishlistList = this.querySelector('[data-wishlist-dialog-el="wishlist-list"]')

    this.productTitle = this.querySelector('[data-wishlist-dialog-el="title"]')
    this.productSize = this.querySelector('[data-wishlist-dialog-el="variant"]')
    this.productImage = this.querySelector('[data-wishlist-dialog-el="image"]')

    this.addMenu = this.querySelector('[data-wishlist-dialog-el="addMenu"]')
    this.createMenu = this.querySelector('[data-wishlist-dialog-el="createMenu"]')
    this.addMenuTrigger = this.querySelector('[data-wishlist-dialog-el="showAddMenu"]')
    this.createMenuTrigger = this.querySelector('[data-wishlist-dialog-el="showCreateMenu"]')

    this.addToWishlistTrigger = this.querySelector('[data-wishlist-dialog-el="addTrigger"]')
    this.removeFromWishlistTrigger = this.querySelector('[data-wishlist-dialog-el="removeTrigger"]')
    this.addWishlistInput = this.querySelector('[data-wishlist-dialog-el="create-input"]')
    this.addWishlistTrigger = this.querySelector('[data-wishlist-dialog-el="createTrigger"]')

    this.setupListeners()
  }

  setupListeners () {
    window.addEventListener(window.theme.wishlist.eventBus.wishlist_intent, (event) => {
      this.handleWishlistIntent(event)
    })

    window.addEventListener(window.theme.wishlist.eventBus.wishlist_added, (event) => {
      this.generateDefaultView()
      this.showAddMenu()
    })

    this.addToWishlistTrigger.addEventListener('click', () => {
      this.handleAddToWishlistClick()
    })

    this.removeFromWishlistTrigger.addEventListener('click', () => {
      this.handleRemoveFromWishlistClick()
    })

    this.addWishlistTrigger.addEventListener('click', () => {
      this.handleAddWishlistClick()
    })

    this.addMenuTrigger.addEventListener('click', () => {
      this.showAddMenu()
    })

    this.createMenuTrigger.addEventListener('click', () => {
      this.showCreateMenu()
    })

    this.wishlistList.addEventListener('change', (event) => {
      this.handleRadioChange(event)
    })

    this.addWishlistInput.addEventListener('input', () => {
      this.debounce(this.handleWishlistNameInput(), 300)
    })
  }

  handleWishlistIntent (event) {
    this.generateDefaultView()
    this.generateProductCard(event.detail)
    this.handleButtonState()
    this.modalDialog.setAttribute('open', true)
  }

  async generateDefaultView () {
    const wishlists = await this.fetchWishlists()

    if (wishlists.length > 0) {
      this.selectedWishlist = wishlists[0].lid
      this.generateWishlistList(wishlists)
    } else {
      this.showCreateMenu(true)
    }
  }

  generateWishlistList (wishlists) {
    const fragment = document.createDocumentFragment()

    wishlists.forEach((wishlist) => {
      this.wishlistName = wishlist.lprops?.name || wishlist.lname
      if (/^\d{12,}$/.test(wishlist.lname) || wishlist.lname.includes(wishlist.lid)) {
        this.wishlistName = 'Wishlist'
      }

      const listItem = document.createElement('li')
      listItem.className = 'wishlist-dialog__form-item'
      listItem.innerHTML = `
        <input
          type="radio"
          name="wishlist"
          value="${wishlist.lid}"
          id="wishlist-${wishlist.lid}"
          class="wishlist-dialog__form-group-input"
          ${wishlist.lid === wishlists[0].lid ? 'checked' : ''}
        />

        <label
          for="wishlist-${wishlist.lid}"
          class="wishlist-dialog__form-group-title"
        >
          ${this.wishlistName}
        </label>
      `

      fragment.appendChild(listItem)
    })

    this.wishlistList.innerHTML = ''
    this.wishlistList.appendChild(fragment)
  }

  generateProductCard (product) {
    this.selectedProduct = {
      variantId: Number(product.variantId),
      productId: Number(product.productId),
      productUrl: product.productUrl,
    }

    this.handleProductRequest(product)
  }

  async handleProductRequest (product) {
    try {
      const request = await fetch(`${product.productUrl.split('?')[0]}.json`)
      const response = await request.json()

      this.productTitle.textContent = response.product.title
      this.productImage.src = response.product.image.src.replace('.jpg', '_150x.jpg')
      this.productImage.alt = response.product.image.alt || response.product.title
    } catch (error) {
      console.error('Error:', error)
    }
  }

  handleAddToWishlistClick () {
    const event = new CustomEvent(window.theme.wishlist.eventBus.wishlist_add_product, {
      detail: {
        wishlistId: this.selectedWishlist,
        variantId: this.selectedProduct.variantId,
        productId: this.selectedProduct.productId,
        productUrl: this.selectedProduct.productUrl,
      },
    })

    window.dispatchEvent(event)

    this.modalDialog.removeAttribute('open')
  }

  handleRemoveFromWishlistClick () {
    const event = new CustomEvent(window.theme.wishlist.eventBus.wishlist_remove_product, {
      detail: {
        wishlistId: this.selectedWishlist,
        variantId: this.selectedProduct.variantId,
        productId: this.selectedProduct.productId,
        productUrl: this.selectedProduct.productUrl,
      },
    })

    window.dispatchEvent(event)

    this.modalDialog.removeAttribute('open')
  }

  handleAddWishlistClick () {
    const event = new CustomEvent(window.theme.wishlist.eventBus.wishlist_add, {
      detail: {
        name: this.addWishlistInput.value,
      },
    })

    window.dispatchEvent(event)
  }

  showAddMenu () {
    this.addMenuTrigger.removeAttribute('aria-hidden')
    this.addMenu.removeAttribute('aria-hidden')
    this.createMenu.setAttribute('aria-hidden', true)
  }

  showCreateMenu (noWishlists) {
    if (this.addWishlistInput) this.addWishlistInput.value = ''
    if (noWishlists) this.addMenuTrigger.setAttribute('aria-hidden', true)

    this.addMenu.setAttribute('aria-hidden', true)
    this.createMenu.removeAttribute('aria-hidden')
  }

  handleRadioChange (event) {
    this.selectedWishlist = event.target.value

    this.handleButtonState()
  }

  async handleButtonState () {
    this.addToWishlistTrigger.setAttribute('disabled', true)
    this.removeFromWishlistTrigger.setAttribute('disabled', true)

    while (!this.selectedWishlist || !this.selectedProduct) {
      await new Promise(resolve => setTimeout(resolve, 200))
    }

    const wishlists = await this.fetchWishlists()
    const selectedWishlist = wishlists.find((wishlist) => wishlist.lid === this.selectedWishlist)
    const existingProduct = selectedWishlist.listcontents.find((product) => product.epi === this.selectedProduct.variantId)

    if (existingProduct) {
      this.addToWishlistTrigger.setAttribute('disabled', true)
      this.removeFromWishlistTrigger.removeAttribute('disabled')
    } else {
      this.addToWishlistTrigger.removeAttribute('disabled')
      this.removeFromWishlistTrigger.setAttribute('disabled', true)
    }
  }

  async handleWishlistNameInput () {
    const wishlists = await this.fetchWishlists()
    const existingWishlist = wishlists.find((wishlist) => wishlist.lprops?.name === this.addWishlistInput.value || wishlist.lname === this.addWishlistInput.value)

    if (!this.addWishlistInput.checkValidity() || this.addWishlistInput.value.length === 0 || existingWishlist) {
      this.addWishlistTrigger.setAttribute('disabled', true)
    } else {
      this.addWishlistTrigger.removeAttribute('disabled')
    }
  }

  fetchWishlists () {
    return new Promise((resolve) => {
      const onSuccess = function (wishlists) {
        // console.info('fetchWishlists() - Success', wishlists)

        resolve(wishlists)
      }
      const onError = function (error) {
        console.error('fetchWishlists() - Error', error)
      }

      window._swat.fetchLists({
        callbackFn: onSuccess,
        errorFn: onError,
      })
    })
  }

  debounce (func, wait) {
    let timeout
    return function (...args) {
      const later = () => {
        clearTimeout(timeout)
        func.apply(this, args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }
}

customElements.define('wishlist-dialog', WishlistDialog)
